var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "page-wrapper"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "id": "topbar-post-login",
      "color": "transparent",
      "dark": "",
      "dense": "",
      "fixed": "",
      "prominent": ""
    }
  }, [_c('div', {
    staticClass: "mt-7"
  }, [_c('span', [_vm._v("SECRETARIA DE EDUCAÇÃO E ESPORTES")])]), _c('v-spacer'), _c('v-toolbar-title', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "app-icon",
    attrs: {
      "src": "https://cdn.educacao.pe.gov.br/storage/assets/logo_SEE_psh_G02_B_png_779d0caae9.png",
      "alt": "brasão-home-64px"
    }
  })])])], 1), _c('div', {
    attrs: {
      "id": "background-image-wrapper"
    }
  }, [_c('v-container', {
    staticClass: "fill-height d-flex align-center justify-center"
  }, [_c('vue-aos', {
    attrs: {
      "animation-class": "animate__zoomInLeft animate__animated"
    }
  }, [_c('v-row', {
    staticStyle: {
      "height": "80vh"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "7"
    }
  }, [_c('v-card', {
    staticClass: "pt-5 px-10 pb-6 rounded-lg",
    attrs: {
      "elevation": "10",
      "color": "rgba(255, 255, 255, 0.9)"
    }
  }, [_c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.recuperarSenha.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/img/siglasigfoco.svg",
      "alt": "brasão-home-64px"
    }
  }), _c('h1', {
    staticClass: "subtitle-1 blue--text text--darken-4 font-weight-bold"
  }, [_vm._v(" Recuperar Senha ")])])], 1), _c('v-row', [_c('p', [_vm._v(" Informe o "), _c('strong', [_vm._v("CPF e o E-mail")]), _vm._v(" da conta que deseja recuperar senha e clique no botão "), _c('strong', [_vm._v("Recuperar Senha")]), _vm._v(". O sistema enviará um link de acesso para que seja feita a alteração da senha. ")])]), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###.###.###-##',
      expression: "'###.###.###-##'"
    }],
    staticClass: "rounded-lg",
    attrs: {
      "solo": "",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$validarCPF(v);
      }],
      "placeholder": "CPF*",
      "prepend-inner-icon": "mdi-account"
    },
    model: {
      value: _vm.user.cpf,
      callback: function ($$v) {
        _vm.$set(_vm.user, "cpf", $$v);
      },
      expression: "user.cpf"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "rounded-lg",
    attrs: {
      "solo": "",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$email(v);
      }],
      "placeholder": "E-mail*",
      "prepend-inner-icon": "mdi-lock"
    },
    model: {
      value: _vm.user.email,
      callback: function ($$v) {
        _vm.$set(_vm.user, "email", $$v);
      },
      expression: "user.email"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-btn', {
    staticClass: "py-4 px-6 mr-3 rounded-lg",
    attrs: {
      "color": "primary",
      "type": "submit"
    }
  }, [_vm._v(" Recuperar Senha ")]), _c('v-btn', {
    staticClass: "py-4 px-6 mr-3 rounded-lg",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        return _vm.cancelar();
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }